import React from "react";

export default function UserDetailModal({ data, onClose }) {
  if (!data) return null;

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    const d = new Date(dateStr);
    let day = String(d.getUTCDate()).padStart(2, "0");
    let month = String(d.getUTCMonth() + 1).padStart(2, "0");
    let year = d.getUTCFullYear();
    return `${day}-${month}-${year}`;
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-xl w-full max-w-2xl p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
            User Details
          </h2>
          <button
            onClick={onClose}
            className="text-gray-600 dark:text-gray-300 hover:text-gray-900"
          >
            ✕
          </button>
        </div>

        <div className="grid grid-cols-2 gap-x-6 gap-y-3 text-sm">
          <Detail label="ID" value={data.id} />
          <Detail label="Mikrotik ID" value={data.mikrotik_user_id} />
          <Detail label="Mikrotik User" value={data.mikrotik_user} />
          <Detail label="Billing Status" value={data.billing_status} />
          <Detail label="Info" value={data.note} />
          <Detail label="Admin Note" value={data.note1} />
          <Detail label="Created At" value={formatDate(data.created_at)} />
          <Detail label="Updated At" value={formatDate(data.updated_at)} />
        </div>

        <div className="mt-6 text-right">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm rounded bg-gray-600 text-white hover:bg-gray-700"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

const Detail = ({ label, value }) => (
  <div>
    <div className="text-gray-500 dark:text-gray-400 text-xs">{label}</div>
    <div className="text-gray-900 dark:text-gray-100 font-medium break-all">
      {value ?? "-"}
    </div>
  </div>
);
